const DATE_ONLY_YMD_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const DATE_ONLY_DMY_RE = /^(\d{2})\/(\d{2})\/(\d{4})$/;

export const parseDateValue = (value?: string | Date | null) => {
  if (!value) return null;
  if (value instanceof Date) return new Date(value.getTime());

  const raw = String(value).trim();
  if (!raw) return null;

  const ymdMatch = raw.match(DATE_ONLY_YMD_RE);
  if (ymdMatch) {
    const [, year, month, day] = ymdMatch;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const dmyMatch = raw.match(DATE_ONLY_DMY_RE);
  if (dmyMatch) {
    const [, day, month, year] = dmyMatch;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  return new Date(raw);
};

export const formatDate = (isoString?: string) => {
  if (!isoString) return '';

  const date = parseDateValue(isoString);
  if (!date || Number.isNaN(date.getTime())) return isoString;
  return date.toLocaleDateString('en-GB', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export function formatTime(dateString?: string): string {
  if (!dateString) return '';

  const date = parseDateValue(dateString);
  if (!date || Number.isNaN(date.getTime())) return dateString;

  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  };

  return new Intl.DateTimeFormat('en-IN', options).format(date);
}


export const getDatePlusDays = (dateStr?: string, days: number = 0): string => {
  if (!dateStr) return '';
  const d = parseDateValue(dateStr);
  if (!d || Number.isNaN(d.getTime())) return '';
  d.setDate(d.getDate() + days);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
